import { useSetRecoilState } from 'recoil';

import {
  updateInvestmentsTransferPageSelector,
  updateInvestmentsTransferPeriodSelector,
  updateInvestmentsTransferSearchTermSelector,
} from './selector';
import { InvestmentsTransferPeriodDates } from './types';

export const useSecuritiesTransferActions = () => {
  const setInvestmentsTransferSearchTerm = useSetRecoilState(
    updateInvestmentsTransferSearchTermSelector
  );
  const setInvestmentsTransferPeriod = useSetRecoilState(updateInvestmentsTransferPeriodSelector);
  const setInvestmentsTransferPage = useSetRecoilState(updateInvestmentsTransferPageSelector);

  const updateInvestmentsTransferSearchTerm = (value: string) => {
    setInvestmentsTransferSearchTerm(value);
    setInvestmentsTransferPage(1);
  };

  const updateInvestmentsTransferPeriod = (value: InvestmentsTransferPeriodDates | null) => {
    setInvestmentsTransferPeriod(value);
    setInvestmentsTransferPage(1);
  };

  return { updateInvestmentsTransferSearchTerm, updateInvestmentsTransferPeriod };
};
